require("-!/home/travis/build/LIVEauctioneers/bidder-react/node_modules/extract-text-webpack-plugin/dist/loader.js?omit=1&remove=true!style-loader!css-loader!less-loader!/home/travis/build/LIVEauctioneers/bidder-react/node_modules/@liveauctioneers/font-awesome-webpack/font-awesome-styles.loader.js!/home/travis/build/LIVEauctioneers/bidder-react/src/theme/font-awesome.config.prod.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/@liveauctioneers/font-awesome-webpack/index.loader.js!./src/theme/font-awesome.config.prod.js
// module id = nrOz
// module chunks = 46